import React from 'react';
import { Header, Page, Text, Wrapper } from '../ReviewPage/ReviewPage.styles';
import { ReactComponent as SuccessImage } from './../../images/success.svg';

const ThankYouPage = ({ data }) => {
	return (
		<Page>
			<Wrapper>
				<Header>{data.title}</Header>
				<Text>{data.subtitle}</Text>
				<SuccessImage />
				<Text style={{ fontWeight: 600 }}>{data.thankYouText}</Text>
			</Wrapper>
		</Page>
	);
};

export default ThankYouPage;
